<template>
  <a-select v-model="selectedValue" mode="multiple" placeholder="请选择推送消息的群聊" :filter-option="false" show-search @search="handleSearch">
    <a-select-option v-for="(chat, index) in filteredChatList" :key="index" :value="chat.chat_id"> {{ chat.name }} ({{ chat.chat_id }}) </a-select-option>
  </a-select>
</template>

<script>
import { feiShuChatList } from '@/api/system/service';
import { debounce } from 'lodash';

export default {
  name: 'ChatSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Array],
      default: () => []
    }
  },
  data() {
    return {
      chatList: [],
      selectedValue: this.value,
      searchKeyword: ''
    };
  },
  computed: {
    filteredChatList() {
      const searchText = this.searchKeyword.toLowerCase();
      if (searchText === '') {
        return this.chatList;
      }
      return this.chatList.filter(chat => chat.name.toLowerCase().includes(searchText) || chat.chat_id.toLowerCase().includes(searchText));
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selectedValue = val;
      },
      immediate: true
    },
    selectedValue(val) {
      this.$emit('change', val);
      this.searchKeyword = '';
    }
  },
  created() {
    this.getFeiShuChatList();
  },
  methods: {
    getFeiShuChatList() {
      feiShuChatList({}).then(response => {
        this.chatList = response.data.items;
      });
    },
    handleSearch: debounce(function (value) {
      this.searchKeyword = value;
    }, 300)
  }
};
</script>
